import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import {
  DialogService,
  DialogType,
} from "src/app/shared/services/dialog.service";
import { ToastService } from "src/app/shared/toast.service";
import { TsaRemovalService } from "src/app/shared/tsa-removal.service";
import { BuildingSurveyViewModel } from "../../../shared/Models/buildingTableViewModel";
import { RemoveGroupFromBuildingsDto } from "../../../shared/Models/write/RemoveGroupFromBuildingsDto";
import { BuildingGroupService } from "../../building-list/services/building-group.service";

@Component({
  selector: "app-delete-buildings-from-modal",
  templateUrl: "./remove-group-from-buildings-modal.component.html",
  styleUrls: ["./remove-group-from-buildings-modal.component.scss"],
})
export class RemoveGroupFromBuildingsModalComponent implements OnDestroy {
  @Output()
  passEntry: EventEmitter<RemoveGroupFromBuildingsDto> = new EventEmitter();
  @Output() reloadBuildingList: EventEmitter<any> = new EventEmitter();

  @Input() buildings: BuildingSurveyViewModel[];

  constructor(
    public activeModal: NgbActiveModal,
    private buildingGroupService: BuildingGroupService,
    private toastService: ToastService,
    private tsaRemovalService: TsaRemovalService,
    private dialogService: DialogService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onDecision(decision) {
    if (decision) {
      var detailText =
        this.tsaRemovalService.getRemarkForBuildingSurveyViewModels(
          this.buildings,
          ""
        );

      if (detailText)
        this.dialogService
          .openDialog({
            headerText: $localize`:@@buildinggroup.removebuildinggroups.title:Remove buildings from building group`,
            detailText: detailText,
            dialogType: DialogType.Continue,
            zIndex: 99999,
            fullscreen: true,
          })
          .pipe(first())
          .subscribe((feedback) => {
            if (feedback) this.handleRemoveFromBuildingGroup();
          });
      else this.handleRemoveFromBuildingGroup();
    }

    this.activeModal.close();
  }

  handleRemoveFromBuildingGroup() {
    const dto = new RemoveGroupFromBuildingsDto({
      buildingIds: this.buildings.map((b) => b.buildingId),
    });
    this.buildingGroupService
      .removeGroupFromBuildings(dto)
      .pipe(first())
      .subscribe(
        (res) => {
          this.buildings.forEach((b) => (b.buildingGroupId = null));
          this.passEntry.emit(dto);
          this.reloadBuildingList.emit();
        },
        (err) => {
          this.toastService.showErrorToast(
            $localize`:@@general.error:Something went wrong`,
            $localize`:@@bg.buildingremove.error:Something went wrong while removing the building from the building group.`
          );
        }
      );
  }
}
